<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-mail-subscription-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Mail Subscription
            </h4>
          </div>

          <div class="modal-body">
            <SelectFormGroup
                v-model="data.frequency"
                name="frequency"
                label="Frequency"
                :error="getError('frequency')"
                :options="frequencyOptions"
            />

            <CheckboxFormGroup
                v-if="externalMailingListInterests?.length > 0"
                v-model="data.interests"
                name="interests"
                label="Interests"
                :error="getError('interests')"
                :options="externalMailingListInterestOptions"
            />

            <LoadingSpinner v-if="loadingExternalMailingListInterests"/>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import CheckboxFormGroup from '@/vendor/forms/FormGroups/Block/Checkbox'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {CheckboxFormGroup,LoadingSpinner,SelectFormGroup},

  mixins: [Errors],

  props: [ 'mailSubscription'],

  data() {
    return {
      data: {},

      externalMailingListInterests: null,

      loadingExternalMailingListInterests: false
    }
  },

  mounted() {
    this.listenForClose()
  },

  watch: {
    mailSubscription() {
      this.getInterests()

      this.data = {...this.mailSubscription.attributes}
    }
  },

  computed: {
    externalMailingListInterestOptions() {
      if(this.externalMailingListInterests === null){
        return null
      }

      return this.externalMailingListInterests.map(externalMailingListInterest => {
        return {
          value: externalMailingListInterest.id,
          label: externalMailingListInterest.attributes.name
        }
      })
    },

    frequencyOptions() {
      return [
        {value: 'low', label: 'Lav'},
        {value: 'medium', label: 'Mellem'},
        {value: 'high', label: 'Høj'}
      ]
    }
  },

  methods: {
    listenForClose() {
      $('#edit-mail-subscription-modal').on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/external/mail-subscriptions/' + this.mailSubscription.attributes.list_id + '/' + this.mailSubscription.id, this.data)
          .then(response => {
            this.data = response.data.data

            notify.success('The mail subscription was updated')

            this.$emit('updated', response.data.data)

            $('#edit-mail-subscription-modal').modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    getInterests() {
      this.loadingExternalMailingListInterests = true

      this.externalMailingListInterests = null

      http.get('/api/v2/external/mailing-lists/' + this.mailSubscription.attributes.list_id +'/interests').then(response => {
        this.externalMailingListInterests = response.data.data

        this.loadingExternalMailingListInterests = false
      })
    },

    reset() {
      this.errors = {}

      this.data = {...this.mailSubscription.attributes}
    }
  }
}
</script>
